export function formatLastSeen(unix) {
  if (!unix) return "Ikke sett";

  const timestamp = unix < 1e12 ? unix * 1000 : unix;
  const msAgo = Date.now() - timestamp;

  const minutes = Math.floor(msAgo / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days} ${days === 1 ? "dag" : "dager"}`;
  if (hours > 0) return `${hours} ${hours === 1 ? "time" : "timer"}`;
  if (minutes > 0) return `${minutes} ${minutes === 1 ? "minutt" : "minutter"}`;
  return "Akkurat nå";
}
